import React from 'react';
import { connect } from 'react-redux';
import RedDownArrowIcon from '../../../icons/RedDownArrowIcon';
import GreenUpArrowIcon from '../../../icons/GreenUpArrowIcon';
import { arrayIsNotEmpty, isDefined } from '../../../utils';

class SurveyCountSummery extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        const
            {
                surveySummery,
                ahtInSecond,
                showTicketsListPopup
            } = this.props;
        if (!arrayIsNotEmpty(surveySummery))
            return <div></div>
        const max = surveySummery[0].number;

        const summery = surveySummery.map((res, index) => {
            let arrow;
            if (isDefined(res.changes)) {
                if (res.changes > 0) {
                    arrow = <GreenUpArrowIcon />;
                }
                else if (res.changes < 0) {
                    arrow = <RedDownArrowIcon />
                }
            }

            const backgroundColor = `repeating-linear-gradient(45deg,  ${res.barColor},  ${res.barColor} 8px , rgb(237, 239, 248),rgb(237, 239, 248) 10px)`
            const widthPercentage = `${(res.number * 70) / max}%`
            return (<div key={index} style={{ marginBottom: '10px' }} className="flex-container-start">
                <div className="SurveyCountSummery-text flex-container-end" style={{ fontSize: '16px' }}>{res.text}</div>
                <div className="SurveyCountSummery-bar"
                    style={{ background: backgroundColor, width: widthPercentage }}></div>
                <div style={{ marginRight: '10px' }} >{res.number}</div>
                {isDefined(res.rate) && <div style={{ color: 'gray' }}>{res.rate}</div>}
                {arrow}
                {isDefined(res.changes) && <div style={{ color: 'gray' }}>{Math.abs(res.changes)}%</div>}
                {isDefined(res.changes) && <div style={{ color: 'gray' }} className="chart_stork flex-container-center">1 week</div>}
            </div>)
        });

        let totalSeconds = ahtInSecond;
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        return <div className="system-dashboard-jibe-border SurveyCountSummery-main"
            style={{
                boxShadow: 'none', padding: '24px 24px 0 24px',
                backgroundImage: `url(${`../../../../../Assets/Images/V3Design/profileAgentNoAvatar.png`})`
            }}>
            <div className="flex-container" style={{ minHeight: '38px', margin: '0 0 15px 0', borderBottom: '1px solid #E6F7F8', }}>
                <div className="title-primary-400-24-28">
                    Survey Count
                </div>
                <div className="v3-button agent-view-interactions"
                    style={{ background: '#E6F7F8', padding: '13px 17px', marginTop: '0' }}
                    onClick={showTicketsListPopup}>
                    See All Tickets
                </div>
            </div>
            <div className="flex-container-start-align-start">
                <div style={{ width: '77%' }}>
                    {summery}
                </div>
                {/*<div className="flex-container-start" style={{ marginRight: '75px' }} >*/}
                {/*    <div>*/}
                {/*        <div className="eighteen-regular-primary-color" style={{ justifyContent: 'center' }}>AHT</div>*/}
                {/*    </div>*/}
                {/*    <div>*/}
                {/*        {hours > 0 && <div className="flex-container-start">*/}
                {/*            <div className="SurveyCountSummery-time">{hours}</div>*/}
                {/*            <div className="SurveyCountSummery-min-second">hours</div>*/}
                {/*        </div>}*/}
                {/*        {minutes > 0 && <div className="flex-container-start">*/}
                {/*            <div className="SurveyCountSummery-time">{minutes}</div>*/}
                {/*            <div className="SurveyCountSummery-min-second">min</div>*/}
                {/*        </div>}*/}
                {/*        {seconds > 0 && <div className="flex-container-start">*/}
                {/*            <div className="SurveyCountSummery-time">{seconds}</div>*/}
                {/*            <div className="SurveyCountSummery-min-second">s</div>*/}
                {/*        </div>}*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>
    }
}

const select = state => ({});

export default connect(select)(SurveyCountSummery);